import _extends from 'babel-runtime/helpers/extends';
import React from 'react';
import BodyComponent from '../base/body';

export default function ListBody(props) {
    return React.createElement(BodyComponent, _extends({ component: 'div' }, props));
}